import axios from "axios";
import config from "../../../../../config";

export const URL = config.URL;

// CREATE =>  POST: add a new data to the server
export function addNewData(data, type) {
  // return axios.post(URL, { data });
  if(type === 'payment'){
    return axios.post(`${URL}transactions/create-business`, data)
  }
}

// READ
export function getAllDatas() {
  return axios.get(URL);
}

export function getSataById(dataId) {
  return axios.get(`${URL}/${dataId}`);
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findDatas(type, queryParams) {
  // return axios.post(`${URL}/all?`, { queryParams });
  if (type === 'billing_info') {
    return axios.get(`${URL}businesses/${queryParams}/billing-overview`);
  } else if (type === 'accounts') {
    return axios.get(`${URL}/auth/user/all${queryParams}`);
  }
  return axios.get(`${URL}api/log/all${queryParams}`);

}

// UPDATE => PUT: update the data on the server
export function updateData(data) {
  return axios.put(`${URL}/${data.id}`, { data });
}

// UPDATE Status
export function updateStatusForDatas(ids, status) {
  return axios.post(`${URL}/updateStatusFordatas`, {
    ids,
    status
  });
}

// DELETE => delete the data from the server
export function deleteData(dataId) {
  return axios.delete(`${URL}/${dataId}`);
}

// DELETE datas by ids
export function deleteDatas(ids) {
  return axios.post(`${URL}/deletedatas`, { ids });
}
